import React, { useContext } from 'react';
import { UAContext } from '../../context/ua_context';

const UserEmailForm: React.FC = () => {
  const { preselectedNewsletters, userEmail, setUserEmail, setIsUAFormSubmitted } =
    useContext(UAContext);

  // This method allows us to maintain the HTML5 email validation when submitting user email
  const submitUserEmailForm = (event: React.FormEvent): void | false => {
    event.preventDefault();

    if (event.target.checkValidity()) {
      setIsUAFormSubmitted(true);
    }
    return false;
  };

  const renderMobileSubscribeButton: React.ReactNode = (
    <div className='d-md-none mt-35'>
      <div className='col-12 text-center'>
        <button
          className='mobile-ua-subscribe-newsletter-button rounded btn btn-primary fs-5'
          aria-label='sign-up-button'
        >
          Subscribe
        </button>
      </div>
    </div>
  );

  const renderDesktopMobileButton: React.ReactNode = (
    <div className='d-none d-md-inline col-md-4'>
      <button
        className='rounded ms-25 btn btn-primary ps-4 pe-4 pt-2 pb-2 fs-5'
        aria-label='sign-up-button'
      >
        Subscribe
      </button>
    </div>
  );

  return (
    // eslint-disable-next-line max-len
    <div className='account-newsletters-react-user-email-container fixed-bottom pt-1 pb-1 pt-sm-5 pb-sm-5'>
      <div className='container'>
        <h3 className='d-none text-center d-sm-block mb-0'>
          Where should we send{' '}
          {preselectedNewsletters.length > 1 ? (
            <>
              <span>those </span>
              <strong>{preselectedNewsletters.length}</strong>
              <span> newsletters?</span>
            </>
          ) : (
            'this newsletter?'
          )}
        </h3>
        <div className='mt-45 mb-45 row'>
          <form aria-label='user-email-form' onSubmit={submitUserEmailForm}>
            <div className='col-md-8 m-md-auto col-11 m-auto'>
              <div className='row'>
                <div className='col-md-8 col-12'>
                  <input
                    id='user-email'
                    aria-label='email-textbox'
                    className='form-control me-25 pt-2 pb-2 ps-25 pe-25 fs-5'
                    type='email'
                    placeholder='Enter your email'
                    required
                    name='user-email'
                    value={userEmail}
                    onChange={({ target }) => setUserEmail(target.value)}
                  />
                </div>
                {renderDesktopMobileButton}
                {renderMobileSubscribeButton}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    // eslint-disable-next-line max-len
  );
};

export default UserEmailForm;
